@for (configurator of enabledConfigurators; track configurator) {
    <div class="configurator-item">
        <p class="subtitle has-text-tertiary icon-and-text configurator-item-title">
            <span>{{ configurator.title }}</span>
            @if (configurator.info) {
                <span (click)="showModal(configurator.info)" class="icon has-curs-pointer">
                    <i aria-hidden="true" class="tri-infos-circle"></i>
                </span>
            }
        </p>
        @if (configurator.label) {
            <p class="text is-level-2" [innerHTML]="configurator.label"></p>
        }
        <div class="buttons is-block buttons-with-icon">
            @if (configurator.id !== 'EDP') {
                <trg-options
                    class="pqd-inline-options"
                    [options]="configLabels"
                    [availableValues]="configurator.options"
                    [checkedValue]="configurator.selected"
                    (onSelectOption)="selectConfigurator(configurator, $event)"
                ></trg-options>
            }
            @if (configurator.id === 'EDP' && fundings?.length > 0) {
                <div>
                    <btl-funding-configurator
                        [isWithoutTax]="isWithoutTax"
                        [fundings]="fundings"
                        (onSelectFunding)="selectConfigurator(configurator, $event)"
                    ></btl-funding-configurator>
                </div>
            }
        </div>
    </div>
}
